<template>
  <div class="bg-white rounded-xl shadow-sm p-6 min-h-[calc(100vh-2rem)]">
    <h2 class="text-xl font-bold text-gray-800 mb-6">个人资料</h2>
    <div class="text-gray-500">
      个人资料页面内容
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfile'
}
</script>
